var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.127,
    height: 19.855,
    viewBox: "0 0 15.127 19.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6731",
    "data-name": "Path 6731",
    d: "M5.891,7.618h.945V5.727a4.727,4.727,0,0,1,9.455,0V7.618h.945a1.9,1.9,0,0,1,1.891,1.891v9.455a1.9,1.9,0,0,1-1.891,1.891H5.891A1.9,1.9,0,0,1,4,18.964V9.509A1.9,1.9,0,0,1,5.891,7.618Zm5.673,8.509a1.891,1.891,0,1,0-1.891-1.891A1.9,1.9,0,0,0,11.564,16.127ZM14.4,7.618V5.727a2.836,2.836,0,0,0-5.673,0V7.618Z",
    transform: "translate(-4 -1)",
    fill: "#FE4C4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedIcon);
export default __webpack_public_path__ + "static/media/locked_icon.52a55b1b7c9fde73c9d1cf53ea6bf7bb.svg";
export { ForwardRef as ReactComponent };